const config = {
  API_URL: "https://af-ega-beacon-demo.ega-archive.org/api",
  LIFTOVER_URL: "https://beacon-liftover.ega-archive.org/liftover/",
};

export default config;
